var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-area-content"},[_c('ProfileForm',{ref:"profileForm",on:{"languageChanged":function($event){return _vm.$emit('languageChanged', $event)},"avatar-changed":function($event){return _vm.$emit('avatar-changed', $event)},"save-personal-data":function($event){return _vm.$emit('save-personal-data', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }